/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import InputField from "components/fields/InputField";
import { Select, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AutoComplete from "react-select";
import SweetAlert2 from "react-sweetalert2";
// import { Tooltip, IconButton } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { MdOutlineContentCopy } from "react-icons/md";
import Radio from "components/radio/index";
import { FaAngleLeft } from "react-icons/fa";

const initialData: {
  name: string;
  merc_description: string;
  support_email: string;
  restricted_ips: string;
  is_batch_postback: string;
  is_agent_merchant: string;
  // auth1: string;
  // auth2: string;
} = {
  name: "",
  merc_description: "",
  support_email: "",
  restricted_ips: "",
  is_batch_postback: "no",
  is_agent_merchant: "no",
  // auth1: "",
  // auth2: ""
};

const CreateMerchant = () => {
  const [newMerchant, setNewMerchant] = useState<any>(initialData);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  // const [agentList, setAgentList] = useState<any>(null);
  const [swalProps, setSwalProps] = useState<any>({});

  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();

  const agentAutoCompleteRef = useRef(null);
  const [agentAutoCompleteOptions, setAgentAutoCompleteOptions] =
    useState<any>(null);

  const handleInputChange = async (event: any) => {
    const { id, value } = event.target;
    setNewMerchant({ ...newMerchant, [id]: value });
  };

  useEffect(() => {
    const fetchData = async () => {
      // await fetchAgents();
      setIsLoading(false);
    };

    fetchData();
    // generateMerchantAPIKey();
    // generateMerchantAPISecret();
  }, []);

  const isValidIPList = (input: string): boolean => {
    if (typeof input !== "string") return false;

    const trimmed = input.trim();
    if (trimmed === "") return true; // allow empty

    const parts = trimmed.split(",").map((p) => p.trim());

    for (const ip of parts) {
      // must not be empty
      if (!ip) return false;

      const segments = ip.split(".");
      if (segments.length !== 4) return false;

      for (const seg of segments) {
        if (!/^\d+$/.test(seg)) return false;
        const num = Number(seg);
        if (num < 0 || num > 255) return false;
      }
    }

    return true;
  };

  const isFormValid =
    newMerchant !== null
      ? newMerchant.name &&
        newMerchant.merc_description &&
        isValidIPList(newMerchant.restricted_ips)
      : // && newMerchant.auth1 &&
        // newMerchant.auth2
        false;

  const handleSubmit = async () => {
    if (isFormValid) {
      newMerchant.username = localStorage.getItem("username");
      newMerchant.userRole = userRole;

      try {
        setIsCreating(true);
        await axios
          .post(
            process.env.REACT_APP_API_URL +
              `/api/${userRole}/merchant/action/create-merchant`,
            newMerchant
          )
          .then(function (response) {
            if (response && response.data?.status === "ok") {
              setSwalProps({
                show: true,
                icon: "success",
                title: "Success",
                html: "Create merchant successfully",
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsCreating(false);
                  navigate(
                    `/${userRole}/merchants/manage/${response.data?.result?.payload?.id}`
                  );
                },
              });
            } else {
              setIsCreating(false);
              setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: response.data.message,
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsCreating(false);
                },
              });
            }
          })
          .catch(function (error) {
            setIsCreating(false);
            setSwalProps({
              show: true,
              icon: "error",
              title: "Oops!",
              html: error.response.data.message,
              showConfirmButton: true,
              didClose: () => {
                setSwalProps({});
                setIsCreating(false);
              },
            });
          });
      } catch (error: any) {
        setIsCreating(false);
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Something went wrong, please try again later.",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsCreating(false);
          },
        });
      }
    }
  };

  return (
    <>
      <form>
        <div className="inter mx-auto max-w-5xl space-y-6 rounded-xl bg-white p-12 shadow-lg ring-1 ring-gray-100">
          <div>
            <Button
              type="button"
              isDisabled={isCreating}
              onClick={() => navigate(`/${userRole}/merchants`)}
              className="
                mb-1 inline-flex items-center gap-1
                text-sm font-medium text-gray-700
                transition hover:text-gray-700
                disabled:cursor-not-allowed disabled:opacity-40
                dark:text-gray-400 dark:hover:text-white
              "
            >
              <FaAngleLeft className="text-base" />
              <span>Merchants</span>
            </Button>

            <h2 className="text-left text-2xl font-bold text-navy-700">
              Create Merchant
            </h2>
          </div>

          {/* Section 1: Basic Info */}
          <div className="space-y-4 border-b border-gray-200 pb-8">
            <p className="text-md font-medium tracking-normal text-gray-700">
              Provide the merchant's information
            </p>

            <div className="grid grid-cols-1 gap-8 gap-y-4 md:grid-cols-2">
              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Name"
                  required={true}
                  placeholder="Enter name"
                  id="name"
                  value={newMerchant.name}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Description"
                  required={true}
                  placeholder="Enter description"
                  id="merc_description"
                  value={newMerchant.merc_description}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Support Email"
                  placeholder="Enter support email"
                  id="support_email"
                  value={newMerchant.support_email}
                  type="email"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Restricted IPs"
                  placeholder="Enter restricted IPs"
                  id="restricted_ips"
                  value={newMerchant.restricted_ips}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-navy-700 dark:text-white">
                  Batch Postback
                </label>
                <div className="mt-2 flex items-center gap-6">
                  <label className="inline-flex items-center">
                    <Radio
                      id="is_batch_postback"
                      name="is_batch_postback"
                      disabled={isCreating}
                      label="Enable Batch Postback"
                      checked={newMerchant.is_batch_postback === "yes"}
                      onChange={() =>
                        handleInputChange({
                          target: { id: "is_batch_postback", value: "yes" },
                        })
                      }
                    />{" "}
                    <span className="ml-2 text-sm text-navy-700">Enable</span>
                  </label>
                  <label className="inline-flex items-center">
                    <Radio
                      id="is_batch_postback"
                      name="is_batch_postback"
                      disabled={isCreating}
                      label="Disable Batch Postback"
                      checked={newMerchant.is_batch_postback === "no"}
                      onChange={() =>
                        handleInputChange({
                          target: { id: "is_batch_postback", value: "no" },
                        })
                      }
                    />{" "}
                    <span className="ml-2 text-sm text-navy-700">Disable</span>
                  </label>
                </div>
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-navy-700 dark:text-white">
                  Agent Merchant
                </label>
                <div className="mt-2 flex items-center gap-6">
                  <label className="inline-flex items-center">
                    <Radio
                      id="is_agent_merchant"
                      name="is_agent_merchant"
                      disabled={isCreating}
                      label="Enable Agent Merchant"
                      checked={newMerchant.is_agent_merchant === "yes"}
                      onChange={() =>
                        handleInputChange({
                          target: { id: "is_agent_merchant", value: "yes" },
                        })
                      }
                    />{" "}
                    <span className="ml-2 text-sm text-navy-700">Yes</span>
                  </label>
                  <label className="inline-flex items-center">
                    <Radio
                      id="is_agent_merchant"
                      name="is_agent_merchant"
                      disabled={isCreating}
                      label="Disable Agent Merchant"
                      checked={newMerchant.is_agent_merchant === "no"}
                      onChange={() =>
                        handleInputChange({
                          target: { id: "is_agent_merchant", value: "no" },
                        })
                      }
                    />{" "}
                    <span className="ml-2 text-sm text-navy-700">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="md:text-right">
            <Button
              isDisabled={isCreating}
              onClick={() => navigate(`/${userRole}/merchants`)}
              className="mr-4 rounded-md border border-gray-300 bg-white px-8 py-2 text-sm font-semibold tracking-tight text-gray-700 shadow-sm transition hover:bg-gray-100 hover:text-gray-900 active:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/20 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 md:px-10"
            >
              Back
            </Button>
            <Button
              onClick={() => handleSubmit()}
              isDisabled={!isFormValid || isCreating}
              isLoading={isCreating}
              loadingText="Creating..."
              className="btn-primary relative overflow-hidden rounded-md px-8 py-2.5 font-semibold text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 md:px-10"
            >
              <span className="relative z-0 tracking-tight">
                Create Merchant
              </span>
              <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
            </Button>
          </div>
        </div>
      </form>

      <SweetAlert2
        {...swalProps}
        customClass={{
          actions: "custom-swal2-popup-action",
          title: "custom-swal2-popup-title",
          confirmButton:
            "custom-swal2-popup-action custom-swal2-popup-action-confirm",
          cancelButton:
            "custom-swal2-popup-action custom-swal2-popup-action-cancel",
        }}
      ></SweetAlert2>
    </>
  );
};

export default CreateMerchant;
